<template>
  <Modal
    class="cc-modal"
    width="800"
    footer-hide
    v-model="visibility"
    :title="`${templateName}-域名列表`"
  >
    <div class="content" v-if="data">
      <div class="row">
        <Input
          v-model="domainName"
          placeholder="请输入搜索的模板名称"
          style="width: 300px"
          clearable
        />
        <div style="margin-left: 20px">
          <Button type="primary" style="margin-right: 20px" @click="onSearch"
            >搜索</Button
          >
          <Button @click="onSearchCancel">重置</Button>
        </div>
      </div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
      </Table>
    </div>
    <div class="foot">
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
      <Button @click="onCancel">关闭</Button>
    </div>
  </Modal>
</template>
<script>
import { templatesDomainList } from "api/domain.js";
export default {
  name: "templateInfoListModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      tableLoading: false,
      columns: [
        {
          title: "域名",
          key: "domainName",
          align: "center",
        },
        {
          title: "过期时间",
          key: "expireTime",
          align: "center",
        },
      ],
      templateName: "",
      domainName: "",
      page: 1,
      limit: 10,
      total: 0,
      data: [],
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.req_getList();
        }
      },
    },
  },

  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    async req_getList() {
      try {
        let params = {
          ym: this.domainName,
          id: this.templateId,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await templatesDomainList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.info.list;
          this.total = data.info.total;
          this.templateName = data.name;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    onCancel() {
      this.visibility = false;
    },
    onSearch() {
      this.onPageChange(1);
    },
    onSearchCancel() {
      this.domainName = "";
      this.onPageChange(1);
    },
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .cc-modal {
  .ivu-table-tip td {
    border-bottom: none;
  }
}
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
.row {
  display: flex;
  align-items: center;
  line-height: 60px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.page-tool {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
